module.exports = __webpack_public_path__ + "img/中文版_库尔_湖北.df0caea3.webp";